import { createSlice } from "@reduxjs/toolkit";
import { validateRedirectUrl } from "Utils/navigationValidation";

export type MissionPlannerData = {
  vehicleId: string;
  vehicleName: string;
  vehicleType: VehicleTypeCore;
  semanticMap: string;
  lastContact: number | null;
};

export type AppState = {
  menuIsOpen: boolean;
  missionPlannerData: MissionPlannerData | null;
  currentSemanticMapId: string | null;
  backUrl: string | null;
  showGlobalLoader: boolean;
  activeTooltipVehicleId: string | null;
};

const initialState: AppState = {
  menuIsOpen: false,
  missionPlannerData: null,
  currentSemanticMapId: null,
  backUrl: null,
  showGlobalLoader: false,
  activeTooltipVehicleId: null,
};

export const Slice = createSlice({
  name: "appState",
  initialState,
  reducers: {
    resetAppState: () => initialState,
    setShowGlobalLoader: (state, action) => {
      state.showGlobalLoader = action.payload;
    },
    setBackUrl: (state, action) => {
      state.backUrl = validateRedirectUrl(action.payload)
        ? action.payload
        : null;
    },
    setCurrentSemanticMapId: (state, action) => {
      state.currentSemanticMapId = action.payload;
    },
    setMissionPlannerData: (state, action) => {
      state.missionPlannerData = action.payload;
      return state;
    },
    setActiveTooltipVehicleId: (state, action) => {
      state.activeTooltipVehicleId = action.payload;
      return state;
    },
  },
});

export default Slice;
